import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { ListarEquipesController } from "../../../../Controllers/HelpDesk/Equipes/EquipesControllers";
import { IFiltroAtendimentosAbertos } from "../AtendimentosAbertos";
import { ListarEmpreendimentosController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Select from "react-select";
interface IAtendimentosAbertoProps {
    handleSubmit: (filter: IFiltroAtendimentosAbertos) => void;
    defaultFilter?: IFiltroAtendimentosAbertos;
    setIdEmpreendimento: Dispatch<SetStateAction<number[]>>;
}
export default function FiltroAtendimentosEmAberto(
    props: IAtendimentosAbertoProps
) {
    const filter = props.defaultFilter;
    const handleFilterAtendimentosEmAberto = props.handleSubmit;
    const FormMethods = useForm();
    const { reset } = FormMethods;
    const idEmpreendimentoRef = useRef<any>();
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
    };
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };
    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );
    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);
    const limparFiltro = {
        FL_STATUS: undefined,
        idUsuario: "",
        DS_USUARIO: "",
        ID_EMPREENDIMENTO: [0],
        tempoAbertoMax: 0,
        tempoAbertoMin: 0,
        tempoClienteAguardandoMax: 0,
        tempoClienteAguardandoMin: 0,
        tempoEsperandoClienteMax: 0,
        tempoEsperandoClienteMin: 0,
    };
    return (
        <StickyToolbar active={Boolean(filter)}>
            <FormProvider {...FormMethods}>
                <UnForm
                    handleSubmit={handleFilterAtendimentosEmAberto}
                    className="form-group row"
                    usingContext
                >
                    <div className="col-12 mt-3">
                        <div className="row">
                            <div className="col-12">
                                <UnForm.LazySelect
                                    label="Atendente"
                                    name="idUsuario"
                                    controller={ListarUsuariosController}
                                    registerOptions={{
                                        setValueAs: (v) => {
                                            if (!v) {
                                                return 0;
                                            } else {
                                                return v;
                                            }
                                        },
                                    }}
                                    getDS={(u) => u.DS_NOME}
                                    getKeyValue={(u) => u.ID_USUARIO}
                                    defaultValue={
                                        props.defaultFilter?.idUsuario
                                    }
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <div className="row">
                            <div className="col-12">
                                <UnForm.LazySelect
                                    label="Equipe de atendimento"
                                    name="ID_EQUIPE_HELP_DESK"
                                    controller={ListarEquipesController}
                                    getDS={(u) => u.DS_EQUIPE_HELP_DESK}
                                    getKeyValue={(u) => u.ID_EQUIPE_HELP_DESK}
                                    registerOptions={{
                                        setValueAs: (v) => {
                                            if (!v) {
                                                return "";
                                            } else {
                                                return v;
                                            }
                                        },
                                    }}
                                    defaultValue={
                                        props.defaultFilter?.ID_EQUIPE_HELP_DESK
                                    }
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Status do Atendente</label>
                        <div className="row">
                            <div className="col-12">
                                <UnForm.Select
                                    // className="form-control"
                                    defaultChecked={
                                        props.defaultFilter?.FL_STATUS
                                    }
                                    name="FL_STATUS"
                                    registerOptions={{
                                        setValueAs: (v) => {
                                            if (v === "true") {
                                                return true;
                                            } else if (v === "false") {
                                                return false;
                                            }
                                        },
                                    }}
                                >
                                    <option></option>
                                    <option value={"true"}>Online</option>
                                    <option value={"false"}>Offline</option>
                                </UnForm.Select>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Empreendimento</label>
                        <Select
                            name="ID_EMPREENDIMENTO"
                            ref={idEmpreendimentoRef}
                            options={options}
                            isClearable
                            isMulti
                            onChange={(e) => {
                                props.setIdEmpreendimento(
                                    e.map((value) => value?.value)
                                );
                            }}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            styles={customStyles}
                            placeholder={""}
                            noOptionsMessage={() => "Nenhuma opção"}
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <label>Tempo do atendimento</label>
                        <div className="row">
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="mínimo"
                                    defaultValue={
                                        props.defaultFilter?.tempoAbertoMin
                                    }
                                    name="tempoAbertoMin"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="máximo"
                                    defaultValue={
                                        props.defaultFilter?.tempoAbertoMax
                                    }
                                    name="tempoAbertoMax"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Select
                                    defaultValue={
                                        props.defaultFilter?.tempoAbertoUnity
                                    }
                                    name="tempoAbertoUnity"
                                    label="unidade"
                                >
                                    <option>minutos</option>
                                    <option>horas</option>
                                    <option>dias</option>
                                </UnForm.Select>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Tempo do cliente esperando resposta</label>
                        <div className="row">
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="mínimo"
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoClienteAguardandoMin
                                    }
                                    name="tempoClienteAguardandoMin"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="máximo"
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoClienteAguardandoMax
                                    }
                                    name="tempoClienteAguardandoMax"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Select
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoClienteAguardandoUnity
                                    }
                                    name="tempoClienteAguardandoUnity"
                                    label="unidade"
                                >
                                    <option>minutos</option>
                                    <option>horas</option>
                                    <option>dias</option>
                                </UnForm.Select>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Tempo aguardando o cliente</label>
                        <div className="row">
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="mínimo"
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoEsperandoClienteMin
                                    }
                                    name="tempoEsperandoClienteMin"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Input
                                    type="number"
                                    registerOptions={{
                                        valueAsNumber: true,
                                    }}
                                    label="máximo"
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoEsperandoClienteMax
                                    }
                                    name="tempoEsperandoClienteMax"
                                />
                            </div>
                            <div className="col-4">
                                <UnForm.Select
                                    defaultValue={
                                        props.defaultFilter
                                            ?.tempoEsperandoClienteUnity
                                    }
                                    name="tempoEsperandoClienteUnity"
                                    label="unidade"
                                >
                                    <option>minutos</option>
                                    <option>horas</option>
                                    <option>dias</option>
                                </UnForm.Select>
                            </div>
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <label>Fila de Atendimento</label>
                            <div className="d-flex justify-content-start">
                                <UnForm.Switch
                                    color="success"
                                    name="FL_FILA_ATENDIMENTO"
                                    type="checkbox"
                                    defaultChecked={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                window.sessionStorage.removeItem(
                                    "FILTRO_ATENDIMENTOS_ABERTO"
                                );
                                reset(limparFiltro);
                                limparFiltros();
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
